/**
 * @generated SignedSource<<0bcdd1f260f7ce98d3351c0911eefaa0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CalendarStatus_profileTimeZone$data = {
  readonly timeZone: string;
  readonly userId: string | null;
  readonly calendarId: string | null;
  readonly " $fragmentType": "CalendarStatus_profileTimeZone";
};
export type CalendarStatus_profileTimeZone$key = {
  readonly " $data"?: CalendarStatus_profileTimeZone$data;
  readonly " $fragmentSpreads": FragmentRefs<"CalendarStatus_profileTimeZone">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CalendarStatus_profileTimeZone",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timeZone",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "calendarId",
      "storageKey": null
    }
  ],
  "type": "ProfileTimeZone",
  "abstractKey": null
};

(node as any).hash = "00d9f6dedd280473c449f25544e2c576";

export default node;
